import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function DisableInfo(props) {
    let from, until = '';
    if (props.deactivatedInFsf) {
        const fromParts = props.deactivatedInFsfFrom.split('-');
        const untilParts = props.deactivatedInFsfUntil.split('-');
        from = fromParts[2] + '/' + fromParts[1] + '/' + fromParts[0];
        until = untilParts[2] + '/' + untilParts[1] + '/' + untilParts[0];
    }

    return (
        props.deactivatedInFsf ?
        <div className="fsf-station fsf-station__disable_info">
            <Translation
                translationKey="fitting-station-disable-message"
                placeholder={{ FROM: from, UNTIL: until}}
            />
        </div> : ''
    );
}

DisableInfo.propTypes = {
    deactivatedInFsf: PropTypes.bool.isRequired,
    deactivatedInFsfFrom: PropTypes.string.isRequired,
    deactivatedInFsfUntil: PropTypes.string.isRequired,
};

DisableInfo.defaultProps = {
    deactivatedInFsf: false,
};

export default DisableInfo;
